import { Grid } from "@mui/material";

import { useLayersStep } from "./hooks/useLayersStep";
import { LayersStepFormColumn } from "./LayersStepFormColumn";
import { LayersStepMapColumn } from "./LayersStepMapColumn";

export const LayersStep = () => {
  const { formActions, layerLabels, layerScope, layerUi, mapActions } = useLayersStep();

  const heightClass = "h-[65rem]";

  return (
    <>
      <Grid className={heightClass} item xs={6}>
        <LayersStepMapColumn
          map={{
            actions: mapActions,
            scope: {
              canDraw: layerScope.canDraw,
              defaultCenter: layerScope.buildingCenter,
              drawingObjectId: layerScope.drawingObjectId,
              mapObjects: layerScope.mapObjects,
            },
            ui: {
              isDrawing: layerUi.isDrawing,
              isEditing: layerUi.isEditing,
              selectedObjectId: layerUi.selectedObjectId,
            },
          }}
        />
      </Grid>
      <LayersStepFormColumn
        className={heightClass}
        form={{
          actions: formActions,
          labels: layerLabels,
          scope: { layers: layerScope.layers },
          ui: layerUi,
        }}
      />
    </>
  );
};
